import bindAll from 'lodash.bindall';
import PropTypes from 'prop-types';
import React from 'react';
import VM from '@scratch/scratch-vm';
import {connect} from 'react-redux';
import {sendUnity} from '../lib/unity-bridge.js';

import ControlsComponent from '../components/controls/controls.jsx';

class Controls extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
            'handleGreenFlagClick',
            'handleStopAllClick'
        ]);
    }
    handleGreenFlagClick (e) {
        e.preventDefault();
        sendUnity('gui.greenFlag.click', {shiftKey: !!e.shiftKey});
        if (e.shiftKey) {
            this.props.vm.setTurboMode(!this.props.turbo);
            const next = !this.props.turbo;
            this.props.vm.setTurboMode(next);
            sendUnity('vm.turbo.set', {value: next});
        } else {
            if (!this.props.isStarted) {
                this.props.vm.start();
                sendUnity('vm.start', {});
            }

            sendUnity('vm.greenFlag.before', {});
            this.props.vm.greenFlag();
            sendUnity('vm.greenFlag.after', {});
        }
    }
    handleStopAllClick (e) {
        e.preventDefault();
        sendUnity('gui.stopAll.click', {});
        this.props.vm.stopAll();
        sendUnity('vm.stopAll', {});
    }
    render () {
        const {
            vm, // eslint-disable-line no-unused-vars
            isStarted, // eslint-disable-line no-unused-vars
            projectRunning,
            turbo,
            ...props
        } = this.props;
        return (
            <ControlsComponent
                {...props}
                active={projectRunning}
                turbo={turbo}
                onGreenFlagClick={this.handleGreenFlagClick}
                onStopAllClick={this.handleStopAllClick}
            />
        );
    }
}

Controls.propTypes = {
    isStarted: PropTypes.bool.isRequired,
    projectRunning: PropTypes.bool.isRequired,
    turbo: PropTypes.bool.isRequired,
    vm: PropTypes.instanceOf(VM)
};

const mapStateToProps = state => ({
    isStarted: state.scratchGui.vmStatus.running,
    projectRunning: state.scratchGui.vmStatus.running,
    turbo: state.scratchGui.vmStatus.turbo
});
// no-op function to prevent dispatch prop being passed to component
const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Controls);
